import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table,Card, Spin,Popconfirm, Layout } from 'antd';
import React, { useRef, useState, useEffect } from 'react';
import Highlighter from 'react-highlight-words';
import { useSelector, useDispatch } from 'react-redux';
import Unsubscribe from './Unsubscribe';
import SiderBar from './SiderBar';
import { getMycolletion } from '../../features/MyCollectionSlice';
const {Content} = Layout;

const MyCollection = () => {
 const [activeTabKey2, setActiveTabKey2] = useState('');
 const [Loading, setLoading] = useState(false);
 const [Complete, setComplete] = useState(false);
 const { user: currentUser } = useSelector((state) => state.auth);
 const routes = useSelector((state) => state.collection);
 const id = currentUser.Id;
 const ClientApikey = currentUser.ClientApikey;
 const dispatch = useDispatch(); 

 useEffect(() => {
   dispatch(getMycolletion({ ClientApikey: ClientApikey,id: id }))
 }, [dispatch])

 if(Complete){
   dispatch(getMycolletion({ ClientApikey: ClientApikey,id: id }));
   setComplete(false);
 }
  //removing duplicates from the array 
      const filteredArr = routes.list?.reduce((acc, current) => {
        const x = acc.find(item => item.Controller === current.Controller);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      const firstKey = {...filteredArr};
      const obj = firstKey[Object.keys(firstKey)[0]]?.Controller.toString();

    // adding header tabs from filtered array
    const TabList = filteredArr?.map((currentTab)=>{
      let object = {
          key: currentTab.Controller,
          tab: currentTab.Controller,
        }
      return object;
      })
      function ReturnContent(key) {
        const currentContent = routes.list?.filter((tab)=>{
          return tab.Controller===key;
        })   
        return currentContent;
      }

  const onTab2Change = (key) => {
    setActiveTabKey2(key);
  };
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Path',
      key: 'RouteId',
      ...getColumnSearchProps('Path'),
      sorter: (a, b) => a.Path.length - b.Path.length,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Action',
      dataIndex: 'RouteId',
      key: 'RouteId',
      width: '20%',
      render: (_, record) =>
       routes.list?.length >= 1 ? (
          <Popconfirm title="Sure to Unsubscribe?" onConfirm={() => Unsubscribe(record.RouteId,id,ClientApikey,setLoading,setComplete)}>
            {routes.status==='loading'?<Button disabled style={{borderRadius:10,color:'black',fontWeight:600,backgroundColor:'lightgray'}}>
              <Spin size='small'/> Loading...
            </Button>:<Button style={{borderRadius:10,color:'white',fontWeight:600,backgroundColor:'#00b33c'}}>
              Unsubscribe
            </Button>}
          </Popconfirm>
        ) : null,
    }
  ];

  return (
    <Content style={{marginTop:'5%'}}>  
    <Layout hasSider >
    <SiderBar props='5' />
    <Layout className="site-layout" >
      <Content style={{ margin: '10px 0px 0', overflow: 'initial' }}> 
      <Card
        style={{margin:'10px 15px'}}
        tabList={TabList}
        activeTabKey={activeTabKey2===''?obj:activeTabKey2}
        onTabChange={(key) => {onTab2Change(key);}}>
        {routes.status==='loading'?<Spin size='large'  tip="Loading..." style={{margin:'20% 40%'}} />:<Table columns={columns} dataSource={ReturnContent(activeTabKey2===''?obj:activeTabKey2)} />}
      </Card>
    </Content>
    </Layout>
    </Layout>
    </Content>
  );

}

export default MyCollection